import React, { useState, useEffect, Fragment } from 'react'
import { Formik } from 'formik'
import Form, {
  Grid,
  Col,
  Label,
  Button,
  Field,
  ErrorMessage,
  Row
} from '../../../components/Form'
import FacebookButton from './FacebookButton'
import { loginSchema, signupSchema } from './validationSchema'
import Step from '../components/Step'
import { TERMS_OF_USE_URL, PRIVACY_POLICY_URL } from '../../../utils/constants'
import { useToggle } from '../../../utils/hooks'

const AccountForm = props => {
  const {
    cookies,
    userIsLoggedIn,
    logIn,
    signUp,
    userIsLogginIn,
    completeStep,
    isCompleted,
    isActive
  } = props

  const [showLogin, toggleLogin] = useToggle(userIsLoggedIn)
  const [authError, setAuthError] = useState('')

  useEffect(() => {
    if (userIsLoggedIn) {
      completeStep()
    }
  }, [userIsLoggedIn])

  const handleLogin = values => {
    logIn({
      email: values.email.trim(),
      password: values.password
    }).then(({ login, success }) => {
      if (success) {
        if (login.msg) {
          setAuthError(login.msg)
        } else if (login.id) {
          setAuthError('')
          cookies.set('CookunityAwesomeCookie', login, {
            path: '/',
            domain: '.cookunity.com',
            expires: new Date(Date.now() + process.env.REACT_APP_AUTH_EXP_TOKEN)
          })
        }
      } else {
        setAuthError('Invalid username or password')
      }
    })
  }

  const handleSignup = values => {
    signUp({
      email: values.email.trim(),
      password: values.password,
      firstname: values.firstName.trim(),
      lastname: values.lastName.trim()
    }).then(e => {
      if (e.success) {
        handleLogin(values)
        setAuthError('')
      } else {
        setAuthError(e.error)
      }
    })
  }

  return (
    <Step
      active={isActive}
      completed={isCompleted}
      disabled={isCompleted || !isActive}
      step={1}
      title="Create Account"
      subtitle={
        !isCompleted &&
        (showLogin ? "Don't have an account?" : 'Already have an account?')
      }
      showAction={!isCompleted}
      actionLabel={!isCompleted && (showLogin ? 'Sign Up' : 'Log In')}
      onActionClick={toggleLogin}>
      <div className="cookunity__create_acount_form">
        <Formik
          isInitialValid={false}
          initialValues={{
            email: '',
            password: '',
            firstName: '',
            lastName: '',
            facebookLogin: ''
          }}
          onSubmit={showLogin ? handleLogin : handleSignup}
          validationSchema={showLogin ? loginSchema : signupSchema}>
          {({
            isSubmitting,
            values,
            setFieldValue,
            setFieldTouched,
            validateForm,
            errors,
            isValid,
            setError,
            setValues,
            submitForm,
            setErrors
          }) => (
            <Form>
              <div className="social_media_container">
                <FacebookButton
                  setValues={setValues}
                  submitForm={submitForm}
                  setErrors={setErrors}
                  text={
                    !showLogin
                      ? 'Sign up with Facebook'
                      : 'Log in with Facebook'
                  }
                />
              </div>

              <div className="separator_container">
                <div className="separator" />
                <div className="or">
                  <span>Or</span>
                </div>
                <div className="separator" />
              </div>

              <Grid>
                {!showLogin && (
                  <Fragment>
                    <Col>
                      <Label>First Name</Label>
                      <Field name="firstName" />
                      <ErrorMessage name="firstName" component="div" />
                    </Col>

                    <Col>
                      <Label>Last Name</Label>
                      <Field name="lastName" />
                      <ErrorMessage name="lastName" component="div" />
                    </Col>
                  </Fragment>
                )}

                <Col>
                  <Label>Email</Label>
                  <Field name="email" />
                  {!showLogin && <ErrorMessage name="email" component="div" />}
                </Col>

                <Col>
                  <Label>Password</Label>
                  <Field name="password" type="password" />
                  {!showLogin && (
                    <ErrorMessage name="password" component="div" />
                  )}
                </Col>
              </Grid>

              {!!authError && (
                <Row>
                  <Col>
                    <div className="cookunity__form_error_message">
                      {authError}
                    </div>
                  </Col>
                </Row>
              )}

              <div className="next_step_row">
                <span>
                  By Signing up through the website or Facebook, you agree to
                  our{' '}
                  <a href={TERMS_OF_USE_URL} target="_blank">
                    Terms of Use
                  </a>{' '}
                  and{' '}
                  <a href={PRIVACY_POLICY_URL} target="_blank">
                    Privacy Policy
                  </a>
                </span>

                <Button
                  type="submit"
                  dark
                  large
                  loading={userIsLogginIn}
                  disabled={!isValid}>
                  Next
                </Button>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </Step>
  )
}

export default AccountForm



// WEBPACK FOOTER //
// ./src/modules/Checkout/AccountForm/AccountForm.jsx